import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import cls from 'classnames'; // --> OFF
import Link, { NONE } from '../Link/Link';
import Loader, { BLACK as LOADER_BLACK, SMALL, WHITE as LOADER_WHITE, X_SMALL } from '../Loader/Loader';
import styles from './Button.less';
export const SIZE_XSMALL = 'xs';
export const SIZE_SMALL = 's';
export const SIZE_MEDIUM = 'm';
export const SIZE_LMEDIUM = 'ml';
export const SIZE_XLARGE = 'xl';
export const DEFAULT = 'default';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';
export const QUATERNARY = 'quaternary';
export const ACCENT = 'accent';
export const GHOST = 'ghost';
export const GHOST_WARNING = 'ghost-warning';
export const TRANSPARENT = 'transparent';
export const TRANSPARENT_HOVERABLE = 'transparent-hoverable';
export const BORDERED = 'bordered';
export const NEUTRAL_NOT_SO_LIGHT = 'neutral-not-so-light';
export const INERT = 'inert';
export const WHITE = 'white';
export const TEXT_COLOR_DARK = 'text-color-dark';
export const TEXT_COLOR_LIGHT = 'text-color-light';
export const ACTIVE_COLOR_DEFAULT = 'active-default';
export const ACTIVE_COLOR_AMBIENT = 'active-ambient';
export const ACTIVE_COLOR_LIGHTEST = 'active-lightest';
export const ACTIVE_COLOR_PRIMARY = 'active-primary';
export const DISABLED_COLOR_DEFAULT = 'disabled-default';
export const DISABLED_COLOR_DEEP = 'disabled-deep';
export const LEFT_ICON_POSITION = 'left';
export const RIGHT_ICON_POSITION = 'right';
const CLASS_COLOR_MAP = {
    [DEFAULT]: styles.buttonDefault,
    [PRIMARY]: styles.buttonPrimary,
    [SECONDARY]: styles.buttonSecondary,
    [TERTIARY]: styles.buttonTertiary,
    [QUATERNARY]: styles.buttonQuaternary,
    [ACCENT]: styles.buttonAccent,
    [GHOST]: styles.buttonGhost,
    [GHOST_WARNING]: styles.buttonGhostWarning,
    [TRANSPARENT]: styles.buttonTransparent,
    [TRANSPARENT_HOVERABLE]: styles.buttonTransparentHoverable,
    [BORDERED]: styles.buttonBordered,
    [NEUTRAL_NOT_SO_LIGHT]: styles.buttonNeutralNotSoLight,
    [INERT]: styles.buttonInert,
    [WHITE]: styles.buttonWhite,
};
const CLASS_TEXT_COLOR_MAP = {
    [TEXT_COLOR_DARK]: styles.buttonTextColorDark,
    [TEXT_COLOR_LIGHT]: styles.buttonTextColorLight,
};
const COLOR_LOADER_MAP = {
    [WHITE]: LOADER_BLACK,
};
const CLASS_ICON_POSITION_MAP = {
    [LEFT_ICON_POSITION]: styles.buttonIconLeft,
    [RIGHT_ICON_POSITION]: styles.buttonIconRight,
};
function Button(props, ref) {
    const { type = 'button', color = DEFAULT, block = false, silent = false, size = SIZE_MEDIUM, active = null, activeColor = ACTIVE_COLOR_DEFAULT, className, contentClassName, disabled = false, disabledColor = DISABLED_COLOR_DEFAULT, textColor, withIcon = false, withImage = false, iconPosition = null, href = null, externalURL = false, target = null, withoutPaddings = false, loading = false, textOverflow, wide = false, form, children, ...rest } = props;
    const btnClassName = cls(styles.btn, CLASS_COLOR_MAP[color], textColor ? CLASS_TEXT_COLOR_MAP[textColor] : null, { 'btn--icon': withIcon, 'btn--image': withImage }, `btn--${size}`, {
        'btn--block': block,
        'btn--active': active,
        'btn--active-default': active && activeColor === ACTIVE_COLOR_DEFAULT,
        'btn--active-ambient': active && activeColor === ACTIVE_COLOR_AMBIENT,
        'btn--active-lightest': active && activeColor === ACTIVE_COLOR_LIGHTEST,
        'btn--active-primary': active && activeColor === ACTIVE_COLOR_PRIMARY,
        'btn--disabled': disabled,
        'btn--disabled-default': disabled && disabledColor === DISABLED_COLOR_DEFAULT,
        'btn--disabled-deep': disabled && disabledColor === DISABLED_COLOR_DEEP,
        'btn--without-paddings': withoutPaddings,
        'btn--silent': silent,
        'btn--text-ellipsis': textOverflow === 'ellipsis',
        [styles.btnWide]: wide,
        [styles.btnLoading]: loading,
    }, className);
    if (active !== null) {
        rest['aria-pressed'] = active;
    }
    const content = (_jsxs(React.Fragment, { children: [_jsx("span", { className: cls(styles.btnContentWrapper, iconPosition ? CLASS_ICON_POSITION_MAP[iconPosition] : null, { [styles.btnHideChildren]: loading }, contentClassName), children: children }), loading && (_jsx(Loader, { appearance: COLOR_LOADER_MAP[color] ?? LOADER_WHITE, className: styles.btnLoader, size: size === SIZE_XSMALL ? X_SMALL : SMALL }))] }));
    if (href) {
        if (externalURL || href.startsWith('http') || href.startsWith('mailto')) {
            return (_jsx(Link, { className: btnClassName, href: href, target: target, ...rest, appearance: NONE, children: content }));
        }
        return (_jsx(Link, { className: btnClassName, to: href, ...rest, appearance: NONE, children: content }));
    }
    return (_jsx("button", { ref: ref, className: btnClassName, form: form, type: type, ...rest, children: content }));
}
export default forwardRef(Button);
